<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->

                    <!-- BOTAO DROPDOWN FLUTUANTE COM 3 PONTOS NA NAVBAR DIREITA -->
                        
                    <!-- Row -->
                    <div class="row">

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-25">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'informacoes'}">
                                            <a v-on:click="setTab('informacoes')">
                                                <i class="material-icons">info_outline</i>
                                                Informações
                                            </a>
                                        </li>
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'avaliacoes'}">
                                            <a v-on:click="setTab('avaliacoes')">
                                                <i class="material-icons">assignment</i>
                                                Avaliações
                                            </a>
                                        </li>                       
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'evolucoes'}">
                                            <a v-on:click="setTab('evolucoes')">
                                                <i class="material-icons">question_answer</i>
                                                Evoluções
                                            </a>
                                        </li>
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'documentos'}">
                                            <a v-on:click="setTab('documentos')">
                                                <i class="material-icons">insert_drive_file</i>
                                                PEP
                                            </a>
                                        </li>                                        
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 margin-bottom-10" v-if="data.detalhes">
                            <h4>{{data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA}}</h4>
                        </div>
                        <div class="col-xl-12" v-show="tab == 'informacoes'">

                            <nav id="navigation" v-if="data.detalhes" class="menu-dropdown">
                                <ul id="responsive" style="display: inline-block !important">
                                    <li>
                                        <a class="button small color-secondary">
                                            <i class="material-icons">menu</i>
                                            Opções
                                        </a>
                                        <ul class="dropdown-nav">
                                            <li>
                                                <router-link v-if="$root.user.tipo == 'profissional'" :to="{'name': 'GerenciarReceitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA}}">
                                                    Emitir receita
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{'name': 'Receitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA}}">
                                                    Visualizar receitas
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{'name': 'Receitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA, 't': 'atestados'}}">
                                                    Visualizar atestados
                                                </router-link>
                                            </li>                                            
                                        </ul>
                                    </li>
                                </ul>
                            </nav>                         

                            <h5 class="block-title">
                                <i class="material-icons">info_outline</i>
                                Informações
                            </h5>                            
                            <div class="table-scroll" style="overflow-x: scroll;" v-if="data.detalhes">

                                <table class="table table-bordered table-bordered-default table-force-responsive table-responsive margin-bottom-0">
                                    <tbody>   
                                        <tr>
                                            <td data-label="">
                                                Dados do paciente
                                            </td>
                                            <td data-label="Código" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA || '-' : '-'}}
                                            </td>                 
                                            <td data-label="Atendimento" class="td-50">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NR_ATENDIMENTO || '-' : '-'}}
                                            </td>
                                            <td data-label="Prontuário" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_PRONTUARIO || '-' : '-'}}
                                            </td>    
                                            <td data-label="Sexo" class="td-50">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_SEXO || '-' : '-'}}
                                            </td>
                                            <td data-label="Nascimento" class="td-50 td-50-l" v-if="data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.DT_NASCIMENTO : false">
                                                {{data.detalhes.PESSOA_FISICA.DT_NASCIMENTO | formatDate}}
                                            </td>
                                            <td data-label="Nascimento" class="td-50 td-50-l" v-if="data.detalhes.PESSOA_FISICA ? !data.detalhes.PESSOA_FISICA.DT_NASCIMENTO : true">
                                                -
                                            </td>                                            
                                            <td data-label="Idade" class="td-50">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_IDADE || '-' : '-'}}
                                            </td>
                                            <td data-label="CPF" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_CPF || '-' : '-'}}
                                            </td>
                                            <td data-label="RG" class="td-50">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_IDENTIDADE || '-' : '-'}}
                                            </td>                                     
                                            <td data-label="Convênio" v-if="data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO : false">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO || '-' : '-'}} / Cód: {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NR_DOC_CONVENIO || '-' : '-'}} 
                                                <!-- Val: XXXX -->
                                            </td> 
                                            <td data-label="Convênio" v-if="data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO : true">
                                                -
                                            </td>                                             
                                            <td data-label="Plano">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_PLANO || '-' : '-'}}
                                            </td>   
                                            <td data-label="Responsável">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NM_CONTATO || '-' : '-'}}
                                            </td>                                                                                              
                                            <td data-label="Telefone" v-if="data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE : false">
                                                + {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE || '-' : '-'}} ({{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDD_TELEFONE || '-' : '-'}}) {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_TELEFONE || '-' : '-'}}
                                            </td>   
                                            <td data-label="Telefone" v-if="data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE : true">
                                                -
                                            </td>                                                                                                                                 
                                            <td data-label="E-mail">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_EMAIL || '-' : '-'}}
                                            </td> 
                                            <td data-label="Endereço">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_END || '-' : '-'}}
                                            </td>
                                            <td data-label="Cidade/Estado">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_CID_EST || '-' : '-'}}
                                            </td>                                            
                                            <td style="padding: 0.03px;"></td>
                                        </tr>
                                        
                                    </tbody>
                                </table>  

                                <div class="submit-field" v-if="data.detalhes">
                                    <div class="checkbox disabled margin-bottom-10">
                                        <input type="checkbox" class="" disabled="" readonly="" id="receber-notificacoes" :checked="data.detalhes.PESSOA_FISICA.IE_PERM_SMS_EMAIL == 'S'">
                                        <label for="receber-notificacoes"><span class="checkbox-icon"></span> Permissão para recebimento de notificações por e-mail e SMS.</label>
                                    </div>
                                </div>                                   

                                <table class="table table-bordered table-force-responsive table-bordered-default table-responsive margin-bottom-0">
                                    <tbody>   
                                        <tr>
                                            <td data-label="">
                                                Médico assistente
                                            </td>
                                            <td data-label="Nome do médico">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NM_MEDICO || '-' : '-'}}
                                            </td>                 
                                            <td data-label="CRM" class="td-50 td-50-l">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.NR_CRM || '-' : '-'}}
                                            </td>             
                                            <td data-label="Especialidade" class="td-50">
                                                {{data.detalhes.TWS_ESPECIALIDADE_MEDICA_V ? data.detalhes.TWS_ESPECIALIDADE_MEDICA_V.DS_ESPECIALIDADE || '-' : '-'}}

                                            </td>
                                            <td style="padding: 0.03px;"></td>
                                        </tr>
                                        
                                    </tbody>
                                </table>        

                                <div class="dashboard-box margin-top-0 cards">
                                    <div class="content margin-bottom-10" v-if="data.detalhes.PRESCR_MEDICA_V">
                                        <h5 class="block-title">
                                            <i class="material-icons">list</i>
                                            Medicações
                                        </h5>
<!--                                         <h5 class="block-title ">
                                            <i class="material-icons">list</i>
                                           
                                        </h5> -->
                                        <h5 v-if="data.detalhes.PRESCR_MEDICA_V.length == 0" class="margin-bottom-0 empty">
                                            <i class="material-icons">close</i>                                            
                                            Nenhum resultado encontrado.
                                        </h5>
                                        <ul class="dashboard-box-list" v-if="data.detalhes.PRESCR_MEDICA_V">
                                            <li v-for="(item, index) in data.detalhes.PRESCR_MEDICA_V">
                                                <a class="job-listing card2">
                                                    <div class="job-listing-details">
                                                        <div class="job-listing-description" style="padding-top: 0px;">
                                                            <div class="row">
                                                                <div class="col-lg-12">

                                                                    <h4 style="text-align: right; float: right;">#{{item.NR_PRESCRICAO}}</h4>
                                                                    <p class="margin-bottom-5 margin-top-0">
                                                                        Informações:
                                                                    </p>                                                                        
                                                                    <div style="line-height: 20px; color: #555;">
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Protocolo:</b> {{item.PACIENTE_SETOR.NM_PROTOCOLO}} 
                                                                            <span class="dashboard-status-button green" v-if="item.PACIENTE_SETOR.IE_STATUS == 'A'">Ativo</span>
                                                                            <span class="dashboard-status-button color-gray" v-if="item.PACIENTE_SETOR.IE_STATUS == 'I'">Inativo</span>
                                                                            <span class="dashboard-status-button red" v-if="item.PACIENTE_SETOR.IE_STATUS == 'F'">Finalizado</span>
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Início do protocolo:</b> {{item.PACIENTE_SETOR.DT_INICIO_TRAT | formatDateTime}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR ? item.PACIENTE_SETOR.DT_FINAL_TRAT : false">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Final do protocolo:</b> {{item.PACIENTE_SETOR.DT_FINAL_TRAT | formatDateTime}}
                                                                            <br>
                                                                        </small>                                                                                      
                                                                        <small class="dark">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Número prescrição:</b> {{item.NR_PRESCRICAO}}
                                                                            <br>
                                                                        </small>                      
                                                                        <small class="dark">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Número atendimento:</b> {{item.NR_ATENDIMENTO}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Setor atendimento:</b> {{item.DS_SETOR_ATENDIMENTO}}
                                                                            <br>
                                                                        </small>
                                                                        <small v-if="item.DS_IMPRESSAO">
                                                                            <i class="material-icons">info_outline</i>
                                                                            <b>Tipo:</b> {{item.DS_IMPRESSAO}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="material-icons">people</i>
                                                                            <b>Usuário:</b> {{item.NM_USUARIO.toUpperCase()}}
                                                                            <br>                                                                
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="material-icons">access_time</i>
                                                                            <b>Criado em:</b> {{item.DT_PRESCRICAO_ORIGINAL | formatDateTime}}h
                                                                            <br>
                                                                        </small>                      
                                                                    </div>                                                                 
                                                                    <p class="margin-bottom-0">
                                                                        Itens:
                                                                    </p>
                                                                    <div v-for="item2 in item.PRESCR_MATERIAL" class="margin-top-5 margin-bottom-10" style="font-size: 12px; color: #555;">
                                                                        
                                                                        <b>⦿ Nome:</b> {{item2.DS_REDUZIDA}} <span class="dashboard-status-button red" v-if="item2.IE_SUSPENSO == 'S'" style="font-size: 12px;">Suspenso</span><br>
                                                                        <b>⦿ Intervalo:</b> {{item2.CD_INTERVALO}}<br>
                                                                        <b>⦿ Horários:</b> {{item2.DS_HORARIOS_MEDICO || item2.DS_HORARIOS}}<br>
                                                                        <b>⦿ Aplicação:</b> {{item2.IE_VIA_APLICACAO}}<br>
                                                                        <span v-if="item2.QT_DOSE"><b>⦿ Dose:</b> {{item2.QT_DOSE}} {{item2.CD_UNIDADE_MEDIDA}}<br></span>
                                                                        <span v-if="item2.DT_INICIO_MEDIC"><b>⦿ Início medicação:</b> {{item2.DT_INICIO_MEDIC | formatDate}}<br></span>
                                                                        <!-- INCLUIR STATUS SE ESTA SUSPENSO -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div> 

                                <div v-if="data.detalhes.usuario">
                                    <h5 class="block-title">
                                        <i class="material-icons">settings</i>
                                        Ativar/desativar
                                    </h5>  
                                  
                                    <div class="submit-field">
                                        <div class="checkbox">
                                            <input type="checkbox" id="enviar-sintomas" true-value="1" false-value="0" @click="changeSintomas" v-model="data.detalhes.usuario.enviarSintomas">
                                            <label for="enviar-sintomas"><span class="checkbox-icon"></span> Acompanhamento de sintomas diário ativado (quimioterapia).</label>
                                        </div>
                                    </div>

                                    <router-link :to="{'name': 'Sintomas', 'query': {'c': data.detalhes.usuario.cod}}" class=" button button-gray small block-mobile gray">
                                        Histórico de sintomas
                                    </router-link>

                                </div>  
                            </div>  
                        </div> 

                        <div class="col-xl-12" v-show="tab == 'avaliacoes'">
                            <div class="dashboard-box margin-top-0 cards avaliacoes">
                                <div class="content" v-if="data.avaliacoes">
                                    <h5 class="block-title ">
                                        <i class="material-icons">list</i>
                                        Avaliações realizadas <b>{{data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length > 0 ? "(" + data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length + ")" : ''}}</b>
                                    </h5>
                                    <h5 v-if="data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length == 0" class="empty">
                                        <i class="material-icons">close</i>                                            
                                        Nenhum resultado encontrado.
                                    </h5>
                                    <ul class="dashboard-box-list" v-if="data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V">
                                        <li v-for="(item, index) in data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V" style="padding: 0px; ">
                                            <a class="job-listing card2">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description" style="padding-top: 0px;">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div style="line-height: 110%; padding-top: 0px; margin-top: 0px;" class="margin-bottom-5 v-html" v-html="item.DS_EVOLUCAO">
                                                                </div>
                                                                <div style="line-height: 20px;">
                                                                    <small v-if="item.DS_IMPRESSAO">
                                                                        <i class="material-icons">message</i>
                                                                        Impressão: {{item.DS_IMPRESSAO}}
                                                                        <br>
                                                                    </small>
                                                                    <small>
                                                                        <i class="material-icons">people</i>
                                                                        {{item.NM_USUARIO.toUpperCase()}}
                                                                    </small>
                                                                    <br>                                                                
                                                                    <small>
                                                                        <i class="material-icons">access_time</i>
                                                                        {{item.DT_ATUALIZACAO | formatDateTime}}
                                                                    </small>                      
                                                                </div>                                                                 
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                        </div> 

                        <div class="col-xl-12" v-show="tab == 'evolucoes'">
                            <div class="row">
                                <div class="col-xl-12" v-if="data.detalhes && $root.user.tipo == 'profissional'">
                                    <form method="post" v-if="data.detalhes.ATENDIMENTO_PACIENTE_V" style="width: 100%;" class="margin-bottom-0 margin-top-15" v-on:submit.prevent="submit('evolucoes')">
                                        <div class="row">
                                            <div class="col-lg-7 col-xs-12 col-xl-6 col-md-10">
                                                <div class="submit-field">
                                                    <h5>Adicionar nota clínica:</h5>
                                                    <textarea class="with-border margin-bottom-0" style="min-height: 30px; padding: 10px; line-height: 120%;" rows="5" v-model="form.evolucoes.texto" placeholder="Escreva aqui..."></textarea>
                                                    <!-- <input type="text" class="with-border margin-bottom-0" placeholder="Escreva aqui.." name="pesquisa" v-model="form.pesquisa"> -->
                                                </div>
                                            </div>

                                            <div class="col-xs-8 col-xl-12 col-lg-12 padding-top-12">
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md">
                                                <div class="submit-field">
                                                    <button class="button small color-secondary" type="submit">
                                                        <i class="material-icons">add</i>
                                                        Adicionar
                                                    </button>                                          
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-4 hidden-lg hidden-xl" style="text-align: right;">
                                                <div class="submit-field">
                                                    <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div>
                                                    <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                                    <button class="button small color-secondary" type="submit">
                                                        <i class="material-icons">add</i>
                                                        Adicionar
                                                    </button>                                          
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="hidden-sm hidden-xl margin-top-20"></div> -->
                                    </form>                           
                                </div>

                                <div class="col-lg-12">                        
                                    <div class="dashboard-box margin-top-0 cards">
                                        <div class="content" v-if="data.evolucoes">
                                            <h5 class="block-title ">
                                                <i class="material-icons">list</i>
                                                Últimas evoluções
                                            </h5>
                                            <h5 v-if="data.evolucoes.EVOLUCAO_PACIENTE_LIB_V.length == 0" class="empty">
                                                <i class="material-icons">close</i>                                            
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <ul class="dashboard-box-list" v-if="data.evolucoes.EVOLUCAO_PACIENTE_LIB_V" style="display: block;">
                                                <li v-for="(item, index) in data.evolucoes.EVOLUCAO_PACIENTE_LIB_V" style="padding: 0px;">
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <div style="line-height: 20px;">
                                                                            <small v-if="item.DS_IMPRESSAO">
                                                                                <i class="material-icons">message</i>
                                                                                Impressão: {{item.DS_IMPRESSAO}}
                                                                                <br>
                                                                            </small>
                                                                            <small class="dark">
                                                                                <i class="material-icons">info_outline</i>
                                                                                <b>Número atendimento:</b> {{item.NR_ATENDIMENTO}}
                                                                                <br>
                                                                            </small>
                                                                            <small class="dark">
                                                                                <i class="material-icons">people</i>
                                                                                <b>Usuário:</b> {{item.NM_USUARIO.toUpperCase()}}
                                                                                <br>                                                                
                                                                            </small>                                                               
                                                                            <small class="dark">
                                                                                <i class="material-icons">access_time</i>
                                                                                <b>Criado em:</b> {{item.DT_ATUALIZACAO | formatDateTime}}
                                                                            </small>                      
                                                                        </div>  
                                                                        <div style="line-height: 110%; padding: 10px; margin-top: 10px; border: 1px solid #efefef;" class="margin-bottom-5 v-html" v-html="item.DS_EVOLUCAO">
                                                                        </div>                                                                                                                                       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>                               
                                </div> 
                            </div>                        
                        </div>                        

                        <div class="col-xl-12" v-show="tab == 'documentos'">

                            <div class="row" >
                                <div class="col-lg-12">
                                    <h5 class="block-title">
                                        <i class="material-icons">list</i>
                                        Documentos disponíveis <b v-if="data.documentos">({{data.documentos.itens.length}})</b>
                                    </h5>
                                </div>
                                <div class="col-lg-12" v-if="data.documentos">
                                    <h5 v-if="data.documentos.itens.length == 0" class="empty">
                                        <i class="material-icons">close</i>                                            
                                        Nenhum resultado encontrado.
                                    </h5>
                                </div>
                                <div class="col-lg-12" v-if="data.documentos">
                                    <div class="attachments-container">
                                        <div class="attachment-box" v-on:click="openPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id)" v-for="(item, index) in data.documentos.itens">
                                            <span>
                                                <a style="cursor: pointer;">
                                                    {{item.endereco}}
                                                    <div class="dashboard-status-button color-secondary">
                                                        {{item.listaIndice[4].valor}}
                                                    </div>
                                                </a>
                                            </span>                                               
                                            <i style="width: 100%;">
                                                {{item.listaIndice[2].valor}}
                                                <button type="button" class="button color-primary small float-right" v-on:click.stop.prevent="exportarPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id + '&download=1')" style="height: 20px; padding-top: 0px; padding-bottom: 0px; line-height: 13px; position: relative; left: -32px;">
                                                    <span class="material-icons" style="position: relative; top: 2px;">file_download</span>
                                                    Exportar PDF
                                                </button>                                             
                                            </i>

                                        </div>

                                    </div>
                                    <br><br><br>                                                                                                                                                             
                                </div>
                            </div>   
  
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Pacientes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },        
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "informacoes",
            "data":                 {
                "detalhes":         null,
                "avaliacoes":       null,
                "documentos":       null,
                "evolucoes":        null,
                "medicamentos":     null
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "evolucoes":        {
                    "_cod":             self.$root.user.cod,
                    "_token":           self.$root.user.token,
                    "texto":        ""
                }
            },
        }
    },
    watch: {
                  
    },
    methods: {       
        updateSintomas: function() {
            var self        = this;
            console.log("updateSintomas()", self.data.detalhes.usuario.enviarSintomas);

            loading.show();

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "acao":         "sintomas",
                "usuarioCod":   self.data.detalhes.usuario.cod,
                "enviarSintomas": self.data.detalhes.usuario.enviarSintomas
            };
                
            axios.put("api/pacientes.php", form)
            .then(response => {

                console.log("updateSintomas()", "success", response.data)
                loading.hide();
                alert(response.data.message);

            })
            .catch(error => {

                console.log("updateSintomas()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },
        changeSintomas: function(e) {
            var self        = this;
            console.log("changeSintomas()", e.srcElement);
          
            e.stopPropagation();
            e.preventDefault();
            setTimeout(function() {
                var checked = $("#enviar-sintomas").is(":checked");
                console.log("checked?", $("#enviar-sintomas").is(":checked"))
                
                confirm("Você tem certeza que deseja alterar?", function() {
                    if (checked) {
                        console.log("Setou 0")
                        self.data.detalhes.usuario.enviarSintomas = 0;
                    } else {
                        console.log("Setou 1")
                        self.data.detalhes.usuario.enviarSintomas = 1;
                    }
                    self.$forceUpdate();
                    self.updateSintomas();
                });
            }, 100);
            // setTimeout(function() {

            //     console.log("Valor sintomas:", self.data.detalhes.usuario.enviarSintomas)

            // }, 500);
        },
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;
            if (tab == "informacoes") {
                self.get(true);
            } else {
                self.getTab(tab);
            }
        },                   
        get: function(load) {
            var self        = this;
            console.log("get()");
            if (load) loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA": self.$route.query.CD_PESSOA_FISICA
                    }
                };

                axios.get("api/pacientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.detalhes  = response.data.result;
                    if (load) loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        getTab: function(tab) {
            var self        = this;
            console.log("getTab()", tab);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA": self.$route.query.CD_PESSOA_FISICA,
                        "NR_PRONTUARIO": self.data.detalhes.PESSOA_FISICA ? self.data.detalhes.PESSOA_FISICA.NR_PRONTUARIO : null,
                        "tipo":         tab
                    }
                };

                axios.get("api/pacientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data[tab] = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },       
        openPDF: function(url) {
            console.log("openPDF", url)
            window.open(url, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");
        },
        exportarPDF: function(url) {
            console.log("exportarPDF", url)
            window.open(url, "_system");
        },        
        submit: function(tab) {
            var self            = this;
            console.log("submit", tab, self.form[tab]);
            loading.show();

            self.form[tab].CD_PESSOA_FISICA = self.$route.query.CD_PESSOA_FISICA;
            
            axios.post("api/" + tab + ".php", self.form[tab])
            .then(response => {

                console.log("submit()", tab, "success", response.data)
                loading.hide();
                self.form.evolucoes.texto = "";
                self.getTab(tab);
                // alert(response.data.message);

            })
            .catch(error => {

                console.log("submit()", tab, "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },

    },
    created: function() {
        var self = this;

        if (!self.$route.query.CD_PESSOA_FISICA) {
            self.$root.back();
            return false;
        }

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .submit-field h5 {
        font-weight: 400 !important;
    }

    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .td-50 {
        width: 50%;
        display: inline-block;
    }
    .td-50-l {
        border-right: 0px !important;
    }
    small.dark {
        color: #555;
    }
    small.dark i {
        color: #59ba92;
    }
    .dashboard-status-button.color-secondary {
        top: 8px;
    }
    .menu-dropdown {
        margin-top: 0px;
        right: 3px;
        position: absolute !important;
    }
    .menu-dropdown .button {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .menu-dropdown ul li a:after {
        display: none !important;
    }

    .menu-dropdown ul li ul {
        right: 0px;
        left: auto !important;
        top: 85px;
    }
    .menu-dropdown ul ul:after {
        left: auto !important;
        right: 25px;
        border-bottom: 5px solid #59ba92 !important;
    }
    .menu-dropdown .dropdown-nav {
        background: #59ba92 !important;
    }
    .menu-dropdown .dropdown-nav li a{
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Paciente.vue